module.exports = __webpack_public_path__ + "img/bg5small.b0914753.jpg";